/*
isNew:是否新用户
isImpower：是否授权
isBindMobile:是否绑定手机号
fingerprint:
openId:
sessionid:
mobile:
cyScore:畅由积分
cmccScore:移动积分 
*/
const state = {
	token: '',
	userInfo: {},
	isChangeAccount: false,
	isLoad: false,
	loadCount: 0,
	theme: {}
};

const getters = {
	xgToken: state => {
		return state.token;
	},
	xgIsLoad: state => {
		return state.isLoad;
	},
	xgUserInfo: state => {
		return state.userInfo;
	},
	xgIsChangeAccount: state => {
		return state.isChangeAccount;
	},
	xgTheme: state => {
		return state.theme;
	},
};

const mutations = {
	showLoading(state) {
		state.isLoad = true
	},
	hideLoading(state) {
		state.loadCount = 1
		state.isLoad = false
	},

	xsToken(state, token) {
		state.token = token
	},
	xsUserInfo(state, userInfo) {
		state.userInfo = userInfo
	},
	xsTheme(state, theme) {
		state.theme = theme
	},
	xsIsChangeAccount(state, isChangeAccount) {
		state.isChangeAccount = isChangeAccount
	},
	xsCyScore(state, cyScore) {
		state.userInfo.cyScore = cyScore
	},
	xsCmccScore(state, cmccScore) {
		state.userInfo.cmccScore = cmccScore
	},
	xsIsImpower(state, isImpower) {
		state.userInfo.isImpower = isImpower
	},
	xsSubCyScore(state, cyScore) {
		state.userInfo.cyScore = parseInt(state.userInfo.cyScore) - parseInt(cyScore)
	},
	xsAddCyScore(state, cyScore) {
		state.userInfo.cyScore = parseInt(state.userInfo.cyScore) + parseInt(cyScore)
	},
	xsSubCmccScore(state, cmccScore) {
		state.userInfo.cmccScore = parseInt(state.userInfo.cmccScore) - parseInt(cmccScore)
	},
};

const actions = {

};

export default {
	state,
	getters,
	mutations,
	actions
};
